import { render, staticRenderFns } from "./VirtualGuard.vue?vue&type=template&id=53f96890&"
import script from "./VirtualGuard.vue?vue&type=script&lang=js&"
export * from "./VirtualGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports